import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { PlayerJackpotWin } from '@/api/common';
import { ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { amountWithCurrencySymbol } from '@/helpers/currency';
import { JackpotGemsWinPack } from '@/modules/jackpot/components/JackpotGemsPack';
import { useGetCommonStore } from '@/store';

import { ScJackpotWinnerModal } from './styled';

interface JackpotWinnerModalProps {
  onClose: () => void;
  jackpotWin: PlayerJackpotWin;
}
export const JackpotWinnerModal: FC<JackpotWinnerModalProps> = ({
  onClose,
  jackpotWin,
}) => {
  const { t } = useTranslation('jackpot');
  const useCommonStore = useGetCommonStore();

  const activeJackpot = useCommonStore.use.activeJackpot();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const buttonCloseProps = useMemo(
    () => (isMobileDevice ? { top: 16, right: 16 } : { top: 12, right: 12 }),
    [isMobileDevice]
  );

  const prize = useMemo(
    () =>
      amountWithCurrencySymbol(
        activeJackpot?.currency || 'USD',
        jackpotWin.amountCents / 100
      ),
    [activeJackpot?.currency, jackpotWin.amountCents]
  );

  return (
    <ScJackpotWinnerModal>
      <ButtonClose onClick={onClose} {...buttonCloseProps} />
      <ImageComponent
        alt="jackpot logo"
        className="logo"
        src="/jackpot/logo.webp"
      />
      <div className="congrats">{t('congrats')}</div>
      <div className="prize">
        <div className="sum">{prize}</div>
        <div className="win-text">{t('jackpotYouWon')}</div>
      </div>

      <JackpotGemsWinPack />
    </ScJackpotWinnerModal>
  );
};
